import { Stack, Typography } from "@mui/material"
import { ReactElement, useContext } from "react"

import { useAppDispatch } from "../../../hooks/useDispatch"
import { useGetUserData } from "../../../hooks/useGetUserData"
import { setShowAccountSetUp } from "../../../redux/preferencesSlice"
import { SUPPRESSED } from "../../../redux/types"
import AppButton from "../../buttons/appButton"
import { BUTTON_SPACING } from "../common/config"
import FullScreenTitleContent from "../common/fullScreenTitleContent"
import { AccountSetUpContext } from "../providers/firstLoginProvider"
import { SELECT_ORG_TYPE } from "../screenDispatchers/firstLoginConstants"

/** Displayed to users expecting an invite */
const ExpectingInvite = (): ReactElement => {
    const { setCurrentScreen } = useContext(AccountSetUpContext)
    const { onSignOut } = useGetUserData()
    const dispatch = useAppDispatch()

    return (
        <FullScreenTitleContent
            titlePrimaryColor=""
            titleMain="I am expecting an invite..."
            subtitle="You currently have no pending invites at this time"
            content={
                <Typography
                    variant="h6"
                    fontWeight={400}
                    color="text.secondary"
                >
                    Please reach out to the admin of the organisation you are
                    expecting an invite from and ask them to send you an invite.
                    They can do this from the organisation summary page in their
                    admin portal. If they have already sent you one, they can
                    send it again if required!
                </Typography>
            }
            actionContent={
                <Stack width="100%" spacing={BUTTON_SPACING}>
                    <AppButton
                        fullWidth
                        variant="contained"
                        onClick={() => {
                            onSignOut()
                            dispatch(setShowAccountSetUp(SUPPRESSED))
                        }}
                    >
                        I&apos;ll wait for the invite, log me out
                    </AppButton>
                    <AppButton
                        fullWidth
                        variant="outlined"
                        onClick={() => setCurrentScreen(SELECT_ORG_TYPE)}
                    >
                        Back
                    </AppButton>
                </Stack>
            }
        />
    )
}

export default ExpectingInvite
